import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export interface MaterialEstudio {
  id: number;
  titulo: string;
  descripcion?: string | null;
  pdfUrl: string;
  thumbnailUrl?: string | null;
  especialidad?: string | null;
  tema?: string | null;
  autor?: string | null;
  tipo?: string | null;
  anio?: number | null;
  tags?: string | null;
  activo: boolean;
  creadoEn?: string;
  actualizadoEn?: string | null;
  creadoPorNombre?: string | null;
}

export interface MaterialEstudioCreate {
  id?: number;
  titulo: string;
  descripcion?: string;
  pdfUrl: string;
  thumbnailUrl?: string;
  especialidad?: string;
  tema?: string;
  autor?: string;
  tipo?: string;
  anio?: number;
  tags?: string;
  activo?: boolean;
}

export interface PdfUploadResult {
  url: string;
  downloadUrl: string;
  thumbnailUrl: string;
  success: boolean;
}

class MaterialEstudioService {
  private publicUrl = `${API_BASE_URL}/api/materiales`;
  private adminUrl = `${API_BASE_URL}/api/admin/materiales`;

  async listarActivos(): Promise<MaterialEstudio[]> {
    const { data } = await axios.get(this.publicUrl);
    return data;
  }

  async obtener(id: number): Promise<MaterialEstudio> {
    const { data } = await axios.get(`${this.publicUrl}/${id}`);
    return data;
  }

  async listarTodos(): Promise<MaterialEstudio[]> {
    const { data } = await axios.get(this.adminUrl);
    return data;
  }

  async guardar(material: MaterialEstudioCreate): Promise<MaterialEstudio> {
    const { data } = await axios.post(this.adminUrl, material);
    return data;
  }

  async toggleActivo(id: number): Promise<MaterialEstudio> {
    const { data } = await axios.patch(`${this.adminUrl}/${id}/toggle`);
    return data;
  }

  async eliminar(id: number): Promise<void> {
    await axios.delete(`${this.adminUrl}/${id}`);
  }

  async uploadPdf(file: File, onProgress?: (pct: number) => void): Promise<PdfUploadResult> {
    const form = new FormData();
    form.append('file', file);
    const { data } = await axios.post(`${this.adminUrl}/upload-pdf`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      },
    });
    return data as PdfUploadResult;
  }
}

export const materialEstudioService = new MaterialEstudioService();
export const TIPOS_MATERIAL = [
  { value: 'GUIA', label: 'Guía' },
  { value: 'PROTOCOLO', label: 'Protocolo' },
  { value: 'MANUAL', label: 'Manual' },
  { value: 'ARTICULO', label: 'Artículo' },
  { value: 'CASO_CLINICO', label: 'Caso clínico' },
  { value: 'OTRO', label: 'Otro' },
];
